
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.25 22.507a.75.75 0 010-1.5h4.5a.75.75 0 00.75-.75v-1.5a.75.75 0 011.5 0v1.5a2.252 2.252 0 01-2.25 2.25h-4.5zM20.25 7.507a.75.75 0 01-.75-.75v-1.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 010-1.5h4.5A2.252 2.252 0 0121 5.257v1.5a.75.75 0 01-.75.75zM10.499 24.006c-.071 0-.143-.005-.214-.016l-8.997-1.285A1.505 1.505 0 010 21.22V3.728c0-.703.498-1.32 1.186-1.467L10.163.045A1.51 1.51 0 0112 1.507v21c0 .401-.156.778-.44 1.061a1.49 1.49 0 01-1.061.438zM1.523 3.722L1.5 21.221l9.002 1.285-.002-21-8.977 2.216zM18 16.506a.743.743 0 01-.53-.22l-3-3a.415.415 0 01-.038-.044.71.71 0 01-.125-.2.787.787 0 01-.052-.328.751.751 0 01.068-.274.693.693 0 01.147-.214l3-3a.744.744 0 011.06 0c.142.141.22.33.22.53s-.078.389-.22.53l-1.72 1.72h6.439a.75.75 0 010 1.5H16.81l1.72 1.72a.744.744 0 010 1.06.749.749 0 01-.53.22z"}}),_c('path',{attrs:{"d":"M7.875 13.132c-.62 0-1.125-.505-1.125-1.125 0-.573.425-1.05.992-1.117a.74.74 0 01.133-.012A1.125 1.125 0 019 12.005c0 .621-.505 1.127-1.125 1.127z"}})])
          )
        }
      }
    